import { render, staticRenderFns } from "./ItemOrderBatchRecord.vue?vue&type=template&id=52ab8cc4&scoped=true"
import script from "./ItemOrderBatchRecord.vue?vue&type=script&lang=js"
export * from "./ItemOrderBatchRecord.vue?vue&type=script&lang=js"
import style0 from "./ItemOrderBatchRecord.vue?vue&type=style&index=0&id=52ab8cc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab8cc4",
  null
  
)

export default component.exports